/* eslint-disable no-unused-vars */
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import { initVimeoVideo } from './vimeo.js';
/* eslint-enable no-unused-vars */

import { initCustomCursor } from './cursor.js';
import { initBasics } from './basics.js';
import { initUnitzoeker } from './unitzoeker.js';
import { initScroll } from './scroll.js';
import { initGallery } from './gallery.js';

jQuery(document).ready(function(){

    initBasics();
    initCustomCursor();
    initUnitzoeker();
    initScroll();
    initGallery();

});
